import { faWarning } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
    selectedPackagesRequireShutdown,
    VideoEngineUpdateState,
} from "userful-chronos-app-common-js/dist/models/config/packageUpdates";
import "./UpdateProgressToast.scss";

interface IProps {
    updateProgress: VideoEngineUpdateState;
    hasBlackMagic: boolean;
}

export default function UpdateProgressToast({ updateProgress, hasBlackMagic }: IProps) {
    const { t } = useTranslation();

    if (!updateProgress || updateProgress.status === "NONE") {
        return null;
    }

    const requireShutdown = hasBlackMagic && selectedPackagesRequireShutdown(updateProgress.packages.packagesToUpdate);
    const timeString = updateProgress.start && new Date(updateProgress.start * 1000).toLocaleString();

    return (
        <div className="updateProgressNotification">
            {updateProgress.status == "UPDATING" && (
                <>
                    <div>
                        <FontAwesomeIcon icon={faWarning} className="updateIcon inProgress" />
                    </div>
                    <div>
                        {t("Error.update.updateInProgress", { initiator: updateProgress.initiator, start: timeString })}
                    </div>
                </>
            )}
            {updateProgress.status == "PENDING_REBOOT" && (
                <>
                    <div>
                        <FontAwesomeIcon icon={faWarning} className="updateIcon inProgress" />
                    </div>
                    <div>
                        {requireShutdown
                            ? t("Error.update.pendingShutdown", {
                                  initiator: updateProgress.initiator,
                                  start: timeString,
                              })
                            : t("Error.update.pendingReboot", {
                                  initiator: updateProgress.initiator,
                                  start: timeString,
                              })}
                    </div>
                </>
            )}
            {updateProgress.status == "FAILED" && (
                <>
                    <div>
                        <FontAwesomeIcon icon={faWarning} className="updateIcon updateError" />
                    </div>
                    <div>
                        {t("Error.update.updateFailed", {
                            msg: updateProgress.msg,
                            initiator: updateProgress.initiator,
                            start: timeString,
                        })}
                    </div>
                </>
            )}
        </div>
    );
}
